/* NorthMark — Scroll Fade-In Animations */
(function() {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('nm-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
  );

  function init() {
    document.querySelectorAll('.nm-fade-in').forEach((el) => {
      observer.observe(el);
    });

    // Slow down hero video playback
    var heroVideo = document.querySelector('.nm-hero__video');
    if (heroVideo) {
      heroVideo.playbackRate = 0.5;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify theme editor section events
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }
})();
